import { render, staticRenderFns } from "./FormSomos1ReportComponent.vue?vue&type=template&id=c7a29bde&scoped=true"
import script from "./FormSomos1ReportComponent.vue?vue&type=script&lang=js"
export * from "./FormSomos1ReportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a29bde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7a29bde')) {
      api.createRecord('c7a29bde', component.options)
    } else {
      api.reload('c7a29bde', component.options)
    }
    module.hot.accept("./FormSomos1ReportComponent.vue?vue&type=template&id=c7a29bde&scoped=true", function () {
      api.rerender('c7a29bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/FormSomos1ReportComponent.vue"
export default component.exports